export const LEFT_CARD = 'LEFT_CARD';
export const TABLE_CARD = 'TABLE_CARD';
export const RIGHT_MAIN_CARD = 'RIGHT_MAIN_CARD';
export const FOOTER_CARD = 'FOOTER_CARD';
export const STORE = 'STORE';
export const SKELETON_LOADER_STYLE = {
  margin: '0px 4px',
  display: 'inline-block'
};
export const SKELETON_GRID_STYLE = {
  marginLeft: '-8px'
};

export const SKELETON_LOADER_FOOTER = {
  width: '10%',
  marginLeft: '10px',
  marginRight: '10px'
};
